import { css } from '@emotion/react';
import CheckIcon from '@mui/icons-material/Check';
import { Chip } from '@mui/material';
import { ConfigStatus } from '../DataDisplay/useDisplayConfigState';

const statusChip = css`
  display: flex;
  gap: 0.5rem;
  align-items: center;
`;

export function ConfigStateChip({ configStatus }: { configStatus: ConfigStatus }) {
  return (
    configStatus !== 'initial' && (
      <Chip
        sx={{ mt: '0.5rem' }}
        label={
          <div css={statusChip}>
            {configStatus === 'saved' ? 'Saved' : 'Modified'}
            {configStatus === 'saved' && <CheckIcon fontSize='small' />}
          </div>
        }
        color={configStatus !== 'saved' ? undefined : 'success'}
      />
    )
  );
}
